import { REQUEST_RAW_DATA, RECEIVE_RAW_DATA, FAILED_RAW_DATA } from "./../actions/rawDataActions";

export function rawData(
  state = {
    isFetching: true,
    loadError: false,
    sensor: null,
    fetchPeriod: false,
  },
  action
) {
  switch (action.type) {
    case REQUEST_RAW_DATA:
      return Object.assign({}, state, {
        loadError: false,
        isFetching: true,
      });
    case RECEIVE_RAW_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        domain: false,
        sensor: action.sensor,
        fetchPeriod: action.fetchPeriod,
      });
    case FAILED_RAW_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        loadError: true,
      });
    default:
      return state;
  }
}
